var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.01 27.38C30.78 27.38 29.59 27.18 28.48 26.82C28.3061 26.7614 28.1192 26.7528 27.9406 26.7953C27.762 26.8377 27.599 26.9294 27.47 27.06L25.9 29.03C23.07 27.68 20.42 25.13 19.01 22.2L20.96 20.54C21.23 20.26 21.31 19.87 21.2 19.52C20.83 18.41 20.64 17.22 20.64 15.99C20.64 15.45 20.19 15 19.65 15H16.19C15.65 15 15 15.24 15 15.99C15 25.28 22.73 33 32.01 33C32.72 33 33 32.37 33 31.82V28.37C33 27.83 32.55 27.38 32.01 27.38Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.95276cf8d5fc640963a394b1b3018781.svg";
export { ForwardRef as ReactComponent };